import React from 'react';
import Layout from './src/components/QrLayout';

export const wrapPageElement = ({ element, props }) => {
  return <Layout {...props}>{element}</Layout>;
};